import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CompaniesPage } from "@/features/companies/components/companies-page";
import { ALL_TENANTS } from "@/features/tenants/lib/tenant-filter";

const companiesSearchSchema = z.object({
  tenant: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_authed/_dashboard/companies/")({
  validateSearch: companiesSearchSchema,
  component: CompaniesRoute,
});

function CompaniesRoute() {
  const { tenant } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <CompaniesPage
      tenant={tenant ?? ALL_TENANTS}
      onTenantChange={(next) =>
        void navigate({
          search: (prev) => ({ ...prev, tenant: next === ALL_TENANTS ? undefined : next }),
          replace: true,
          resetScroll: false,
        })
      }
    />
  );
}
